module.exports = __webpack_public_path__ + "static/media/dashboardActive.bf53e8c3.svg";